import {
	APP_CONF_VARS,
} from '@appConf/vars.conf';
import {
	getApiDomainByEnv,
} from '@modules/domain';

const BASE_API_URL = getApiDomainByEnv();
const PRIVATE_BASE = `${BASE_API_URL}${APP_CONF_VARS.privatePath}`;
const PUBLIC_BASE = `${BASE_API_URL}${APP_CONF_VARS.privatePath}/public`;
const SERVICE_LPDI_BASE = getApiDomainByEnv(APP_CONF_VARS.api_service_lpdi_url);
const SF_LEGACY = APP_CONF_VARS.sfLegacyPath;

const privateUrl = (path: string) => `${PRIVATE_BASE}${path}`;
const publicUrl = (path: string) => `${PUBLIC_BASE}${path}`;
const sfUrl = (path: string) => `${BASE_API_URL}${APP_CONF_VARS.sfPath}${path}`;

export const FETCHES = {
	private: {
		addresses: {
			city: privateUrl('/private/addresses?city=eq::city_raw'),
			id: privateUrl('/private/addresses?id=eq::address_id'),
			street_city: privateUrl('/private/addresses?street=eq::street_raw&city=eq::city_raw'),
		},
		brokers: privateUrl('/private/me/company/brokers'),
		companies: {
			_ROOT: `${SERVICE_LPDI_BASE}/v4/companies`,
			buildings: `${SERVICE_LPDI_BASE}/v4/companies/:companyId/buildings?pageSize=:pageSize&pageNumber=:pageNumber&sortBy=:sortBy&sortOrder=:sortOrder`,
			establishments: `${SERVICE_LPDI_BASE}/v4/companies/:companyId/establishments?pageSize=:pageSize&pageNumber=:pageNumber&sortBy=:sortBy&sortOrder=:sortOrder`,
			events: `${SERVICE_LPDI_BASE}/v4/companies/:companyId/events?pageSize=:pageSize&pageNumber=:pageNumber&search=:search&sortBy=:sortBy&sortOrder=:sortOrder`,
			id: `${SERVICE_LPDI_BASE}/v4/companies/:companyId`,
			lands: `${SERVICE_LPDI_BASE}/v4/companies/:companyId/lands?pageSize=:pageSize&pageNumber=:pageNumber&sortBy=:sortBy&sortOrder=:sortOrder`,
			managers: `${SERVICE_LPDI_BASE}/v4/companies/:companyId/managers?pageSize=:pageSize&pageNumber=:pageNumber&sortBy=:sortBy&sortOrder=:sortOrder`,
			transactions: `${SERVICE_LPDI_BASE}/v4/companies/:companyId/transactions?pageSize=:pageSize&pageNumber=:pageNumber&sortBy=:sortBy&sortOrder=:sortOrder`,
		},
		contacts_search: privateUrl('/private/contacts/search?q=eq::query'),
		create_request: privateUrl('/demos/create_request'),
		demands: (() => {
			const base = privateUrl('/private/demands');
			const demandPath = (suffix: string) => `${base}/:demandid${suffix}`;
			const offerPath = (suffix: string) => `${demandPath('/offers')}${suffix}`;
			return {
				_ROOT: base,
				alert_broker: demandPath('/alert/update?type=self_alert'),
				brokers: `${base}/brokers`,
				delete: `${SF_LEGACY}/demandSearch/MultipleDelete`,
				export: `${SF_LEGACY}/demandSearch/searchResultsMetaDemandeCSV?filter[announcement_demand_ids]=[:selectedids]&print=CSV`,
				geo_json: demandPath('/offers/geojson?commercialization_step=eq::step'),
				id: demandPath(''),
				offer: {
					_ROOT: offerPath('/:offerid'),
					application: offerPath('/:offerid/applications'),
					contacts: offerPath('/:offerid/contacts'),
					event_history: offerPath('/:offerid/event_history'),
					lots: offerPath('/:offerid/surfaces'),
					viewed: offerPath('/:offerid/viewed'),
					visit: offerPath('/:offerid/visits'),
				},
				offers: demandPath('/offers'),
				step: demandPath(`/offers?commercialization_step=eq::step&items_per_page=${APP_CONF_VARS.api.demand.offers.limit}`),
				update_view_mode: demandPath('/settings/table'),
			};
		})(),
		document_templates: privateUrl('/private/document_templates'),
		generate_download_pdf: privateUrl('/private/document_templates/:templateid/generate?pdf=true'),
		generate_download_pptx: privateUrl('/private/document_templates/:templateid/generate'),
		generate_tilkee_link: privateUrl('/private/document_templates/:template_id/generate/link'),
		generate_tilkee_link_from_pdf_file: privateUrl('/private/document_templates/generate/link'),
		geojson: `${SERVICE_LPDI_BASE}/v4/geojson?ids=:ids&type=:type&format=:format`,
		logout: privateUrl('/logout'),
		marketers: privateUrl('/private/marketers?company=eq::company'),
		marketers_create: privateUrl('/private/marketers'),
		observatory: {
			report: privateUrl('/private/reports/:reportid'),
			reports: privateUrl('/private/reports'),
		},
		offers: (() => {
			const base = privateUrl('/private/offers');
			const offerPath = (suffix: string) => `${base}/:offerid${suffix}`;
			return {
				_ROOT: base,
				contacts: {
					__ROOT: offerPath('/contacts'),
					contact_id: offerPath('/edit/contacts/:contactid'),
					entry: offerPath('/edit/contacts'),
				},
				default_values: `${base}/edit/default_values`,
				edit: offerPath('/edit'),
				enums: `${base}/enums`,
				id: offerPath(''),
				lots: offerPath('/lots'),
				lots_edit: {
					__ROOT: offerPath('/edit/lots'),
					archive: offerPath('/edit/lots/archive'),
					lot_id: offerPath('/edit/lots/:lotid'),
					total: offerPath('/edit/lots/total'),
					unarchive: offerPath('/edit/lots/unarchive'),
				},
				mass_update: `${base}/mass_update`,
				matching: offerPath('/demands'),
				media: offerPath('/edit/medias'),
				search: `${base}/search`,
				step: offerPath('/demands?commercialization_step=eq::step'),
				validate_mass_update: `${base}/mass_update/validate`,
			};
		})(),
		specifications: (() => {
			const base = privateUrl('/private/specifications');
			const specPath = (suffix: string) => `${base}/:specificationid${suffix}`;
			return {
				_ROOT: base,
				associate: specPath('/offers/:offerid/associate'),
				id: specPath(''),
				ignored: specPath('/offers/ignored'),
				offers: specPath('/offers'),
				status: specPath('/offers/status'),
				update_accepted: specPath('/offers/updated'),
				update_ignored: specPath('/offers/update_ignored'),
				updated: specPath('/offers/:announcementid/updated'),
			};
		})(),
	},
	public: {
		authentification: {
			authentificator_2fa_code: sfUrl('/2fa_check/webapp/sms'),
			authentificator_2fa_request: sfUrl('/2fa/usercode/send'),
			login: privateUrl('/login'),
			please_disconnect: publicUrl('/please_disconnect'),
			reset_password_request: publicUrl('/user/password/reset_request'),
			reset_password_token: publicUrl('/user/password/reset_form'),
		},
		demands: (() => {
			const basePath = `${SERVICE_LPDI_BASE}/internal/public/:segmenturl/shared_demand/:token`;
			const offersPath = `${basePath}/offers`;
			return {
				_ROOT: basePath,
				geo_json: `${offersPath}/geojson?commercialization_step=eq::step`,
				offer: {
					_ROOT: `${offersPath}/:offerid`,
					viewed: `${offersPath}/:offerid/viewed`,
				},
				offers: offersPath,
				step: `${offersPath}?commercialization_step=eq::step&items_per_page=${APP_CONF_VARS.api.demand.offers.limit}`,
				viewed: `${basePath}/viewed`,
			};
		})(),
		me: privateUrl('/me'),
		session: privateUrl('/session'),
	},
};
